var $525f6fa4ac26e278$exports = {};
$525f6fa4ac26e278$exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{5C0B}\u{689D}\u{4EF6}`
};


export {$525f6fa4ac26e278$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
